import {Box, Button, Image} from "grommet";
import React from "react";
import {Logout} from "grommet-icons";
import Logo from "../assets/Asset Sapas/sapas-03.png";
import {deleteRefreshToken, deleteToken, deleteUserID} from "../utils/token";

function handleLogout(event) {
    event.preventDefault();
    deleteToken();
    deleteRefreshToken();
    deleteUserID();
    window.location.href = '/webapp/';

}
const HeaderApp = (props) => {
    return (
        <>
            <Box direction={"row"}
                 height={"xxsmall"}>
                <Image fit="cover"
                       src={Logo}
                />
                {/*<Text size="medium" color="white">SAPAS PET</Text>*/}
            </Box>
            <Box direction="row">
                {/*<Button
                            a11yTitle={dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                            icon={dark ? <Moon/> : <Sun/>}
                            onClick={() => setDark(!dark)}
                            tip={{
                                content: (
                                    <Box
                                        pad="small"
                                        round="small"
                                        background={dark ? "dark-1" : "light-3"}
                                    >
                                        {dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                                    </Box>
                                ),
                                plain: true,
                            }}
                        />*/}
                <Button
                    a11yTitle={"Logout"}
                    icon={<Logout/>}
                    onClick={event => handleLogout(event)}
                    tip={{
                        content: (
                            <Box
                                pad="small"
                                round="small"
                                background={"light-3"}
                            >
                                {"Logout"}
                            </Box>
                        ),
                        plain: true,
                    }}
                />
            </Box>
        </>
    )
        ;
};

export default HeaderApp